module.exports = __webpack_public_path__ + "img/gift4-01-c05-k2.ba5b5af7.png";